<template>
	<div>
		<div class="bg-w pd20" style="min-height: 950px;">
			<a-spin :spinning="loading">
				<div class="mb20" v-if="adminInfo.role_id==1">
					<a-button type="primary" @click="addAccountAct">添加账号</a-button>
				</div>
				<div class="form-seach-box ">
					<a-form layout="inline">
						<a-form-item label="账号名称">
							<a-input v-model="search.username" placeholder="请输入账号名称"></a-input>
						</a-form-item>
						
						<a-form-item>
							<a-button @click="searchAct" type="primary">查询</a-button>
							<a-button @click="cancelAct" class="ml10">取消</a-button>
						</a-form-item>
					</a-form>
				</div>
				
				<div class="mt20">
					<table class="list wxb-table" style="width: 100%;">
						<thead>
							<tr>
								<th>账号名称</th>
								<th>头像</th>
								<th>昵称</th>
								<th>身份</th>
								<th>最后登录的时间</th>
								<th>添加时间</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody class="ft14 ftw400 cl-black" v-if="datas.length>0">
							<tr v-for="(item,index) in datas">
								<td>
									{{item.username}}
								</td>
								<td>
									<div class="flex center alcenter" >
										<img v-if="item.face != null" :src="baseUrl+item.face" class="account-index-table-face"/>
										<img v-else src="../assets/image/face.png" class="account-index-table-face"/>
									</div>
								</td>
								
								<td>{{item.nick_name ? item.nick_name : '-' }}</td>
								<td>{{adminInfo.admin_id==item.admin_id ? '自己' : item.role_mean}}</td>
								<td>
									{{item.last_login_time_format}}
								</td>
								<td><div>{{item.add_time_format}}</div></td>
								<td>
									<div class="flex center alcenter omen-action" >
										<a-dropdown>
											<div class="flex alcenter" >
												<i class="iconfont iconmore_blue ft24 omen-action-icon"/>
											</div>
											<a-menu slot="overlay">
												<a-menu-item v-if="adminInfo.role_id==2 && (item.admin_id != adminInfo.admin_id)">
													<a href="javascript:;"  @click="assignJurisdictionAct(index)">
														<i class="iconfont iconappoint_tab12"></i>
														<span class="ml10">分配权限</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="item.admin_id == adminInfo.admin_id">
													<a href="javascript:;" @click="editPasswordAct(index)">
														<i class="iconfont iconedit"></i>
														<span class="ml10">修改密码</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="adminInfo.role_id==1">
													<a href="javascript:;" @click="adminRoomAct(index)">
														<i class="iconfont iconshop"></i>
														<span class="ml10">查看库房</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="adminInfo.role_id==2 && (item.admin_id != adminInfo.admin_id)">
													<a href="javascript:;" @click="delBindAct(index)">
														<i class="iconfont icondelete"></i>
														<span class="ml10">解绑</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="adminInfo.role_id==1 && (item.admin_id != adminInfo.admin_id)">
													<a href="javascript:;" @click="delAccountAct(index)">
														<i class="iconfont icondelete"></i>
														<span class="ml10">删除账号</span>
													</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</div>
								</td>
							</tr>
						</tbody>
						
						<tbody v-else>
							<tr>
								<td colspan="7">
									<a-empty/>
								</td>
							</tr>
						</tbody>
					</table>
					
					<div class="flex center mt20">
						<a-pagination @change="pageChange" :total="total" v-model="page" :pageSize="pageSize" show-less-items />
					</div>
					<div v-if="addAccountVisible">
						<add-account :visible="addAccountVisible" @cancel="cancelAddAccount" @ok="okAddAccount"></add-account>
					</div>
					<div v-if="editPasswordVisible">
						<edit-password :visible="editPasswordVisible" :admin_id="admin_id" @cancel="cancelEditPassword" @ok="okEditPassword"></edit-password>
					</div>
					<div v-if="adminRoomVisible">
						<admin-room :visible="adminRoomVisible" :admin_id="admin_id" @cancel="cancelAdminRoom"></admin-room>
					</div>
					<div v-if="assignJurisdictionVisible">
						<assign-jurisdiction :visible="assignJurisdictionVisible" :admin="admin"  
						@cancel="cancelAssignJurisdiction" @ok="okAssignJurisdiction"></assign-jurisdiction>
					</div>
				</div>
			</a-spin>
		</div>
	</div>
</template>

<script>
	import {listMixin} from '../common/mixin/list.js';
	import addAccount from './components/account/modal/addAccount.vue';
	import editPassword from './components/account/modal/editPassword.vue';
	import adminRoom from './components/account/modal/adminRoom.vue';
	import assignJurisdiction from './components/account/modal/assignJurisdiction.vue';
	export default{
		mixins:[listMixin],
		components:{
			addAccount,
			editPassword,
			adminRoom,
			assignJurisdiction,
		},
		data(){
			return{
				loading:false,
				addAccountVisible:false,
				editPasswordVisible:false,
				adminRoomVisible:false,
				assignJurisdictionVisible:false,
				admin_id:0,
				admin:{},
				datas:[],
				search:{
					username:'',
				}
			}
		},
		created() {
			// this.setAdminInfo({id:1});
			console.log(this.baseUrl);
		},
		methods:{
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getAccountList',{
					username:this.search.username,
					limit:this.pageSize,
					page:this.page,
				}).then(res=>{
					this.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			//添加账号
			addAccountAct(){
				this.addAccountVisible=true;
			},
			cancelAddAccount(){
				this.addAccountVisible=false;
			},
			okAddAccount(){
				this.addAccountVisible=false;
				this.getLists();
			},
			
			//修改密码
			editPasswordAct(index){
				this.admin_id=this.datas[index].admin_id;
				this.editPasswordVisible=true;
			},
			cancelEditPassword(){
				this.editPasswordVisible=false;
			},
			okEditPassword(){
				this.editPasswordVisible=false;
				this.getLists();
			},
			
			//查看库房
			adminRoomAct(index){
				this.admin_id=this.datas[index].admin_id;
				this.adminRoomVisible=true;
			},
			cancelAdminRoom(){
				this.adminRoomVisible=false;
			},
			
			//分配权限
			assignJurisdictionAct(index){
				this.admin=this.datas[index];
				this.assignJurisdictionVisible=true;
			},
			cancelAssignJurisdiction(){
				this.assignJurisdictionVisible=false;
			},
			okAssignJurisdiction(){
				this.assignJurisdictionVisible=false;
				this.getLists();
			},
			
			delBindAct(index){
				this.$confirm({
					title: '确定解绑吗？',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk: () => {
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delAdminRoomFromTwo', {
								admin_id: this.datas[index].admin_id,
							}).then(res => {
								this.$message.success('操作成功',1,()=>{
									this.getLists();
								});
								
							}).catch(res => {
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
						
					},
				});
			},
			
			delAccountAct(index){
				this.$confirm({
					title: '确定删除这个账号吗？',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk: () => {
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delAdmin', {
								admin_id: this.datas[index].admin_id,
							}).then(res => {
								this.$message.success('操作成功',1,()=>{
									this.getLists();
								});
								
							}).catch(res => {
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
						
					},
				});
			},
			
			searchCancel(){
			    //改变搜索的表单的初始值
				this.search={
					username:'',
				}
			},
		}
	}
</script>

<style>
	.account-index-table-face{
		width: 48px;
		height: 48px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
		border-radius: 40px;
		border: 2px solid #FFFFFF;
	}
</style>
